// import hooks
import { useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../utils/custom-hooks/useWindowSize";

// import components
import ChangeBtn from "./ChangeBtn";
import SaveBtn from "./SaveBtn";
import CustomPhoneInput from "../UI/CustomPhoneInput";

// import assets

// import data

const Phone = ({ phone, onHandleChange }) => {
    const [t] = useTranslation("global");
    const windowWidth = useWindowSize();
    // const [ophone, setPhone] = useState(uphone);

    const [showEdit, setShowEdit] = useState(false);
    return (
        <div className="account-phone-container account-personal-item">
            {!showEdit ? (
                <div className="phone-preview item-preview flex-between-row">
                    <div className="account-personal-txt">
                        <p className="ocean-p-grey">
                            {t("modals.signup.phone")}
                        </p>
                        <p className="ocean-p ocean-p-700">{phone}</p>
                    </div>
                    <ChangeBtn onHandleClick={() => setShowEdit(true)} />
                </div>
            ) : (
                <div
                    className={`account-personal-edit ${
                        windowWidth >= 992
                            ? "flex-between-row"
                            : "flex-center-col"
                    }`}
                >
                    <CustomPhoneInput
                        phone={phone}
                        onHandleChange={onHandleChange}
                    />
                    <SaveBtn onHandleClick={() => setShowEdit(false)} />
                </div>
            )}
        </div>
    );
};

export default Phone;
